fetch(window.Shopify.routes.root + 'search.js?q=-id:1&page=&view=bss.login&sort_by=created-ascending').then(data => data.text()).then( async (data) => {
  const lockedProducts = JSON.parse(data)
  let lockElements = JSON.parse(lockedProducts.lockElements);
  if (lockedProducts?.pages > 1) {
    const pagesResult = await Promise.all(Array(lockedProducts.pages - 1).fill(0).map((_, index) => fetch(window.Shopify.routes.root + `search.js?q=-id:1&page=${index + 2}&view=bss.login&sort_by=created-ascending`)))
    const pagesData = await Promise.all(pagesResult.map(data => data.text()))
    const pageLockElements = pagesData.map(data => JSON.parse(JSON.parse(data).lockElements))
    lockElements = lockElements.concat(...pageLockElements)
  }
  lockElements.forEach((element) => {
    element.lockElement = element.lockElement.replace(/\/search\.js\?page=\d*&q=-id%3a1/, window.location.pathname);
  })
  // handle product card
  const handleProductCard = () => {
    const listpriceElement = $(window.Login.card_product_selector);
    const listElementArray = Array.from(listpriceElement);
    for (let i = 0; i < listElementArray.length; i++) {
      const linkElement = listElementArray[i].querySelector('a[href*="/products/"]');
      const foundLockElement = lockElements.find(element => linkElement.getAttribute('href').includes('/products/' + element.handle)) 
      const priceElement = listElementArray[i].querySelector(window.Login.card_price_element);
      if (priceElement) {
        if (foundLockElement?.lock){
          priceElement.innerHTML = foundLockElement.lockElement;
        }
        priceElement.style.visibility = 'visible';
      }
    }
  }
  handleProductCard();
  const config = { attributes: false, childList: true, subtree: true };
  
  const pCardCallback = (mutationsList) => {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        // product card
        const productCards = $(`${window.Login.card_product_selector}:has(${window.Login.card_price_element})`);
        const productCardArray = Array.from(productCards);
        for (let i = 0; i < productCardArray.length; i++) {
          const linkElement = productCardArray[i].querySelector('a[href*="/products/"]');
          const foundLockElement = lockElements.find(element => linkElement.getAttribute('href').includes('/products/' + element.handle)) 
          const priceElement = productCardArray[i].querySelector(window.Login.card_price_element);
          if (priceElement) {
            const checkPriceElement = priceElement.querySelector(`.bss-lock-element`);
            if (!checkPriceElement) {
              if (foundLockElement?.lock){
                priceElement.innerHTML = foundLockElement.lockElement;
              }
              priceElement.style.visibility = 'visible';
            }
          }
        }
        // handle hide product for predictive search
        handleHideProductForPredictiveSearch(lockElements);
        // predictive search 
        const searchResults = $(`${window.Login.search_product_selector}:has(${window.Login.search_price_selector})`);
        const searchResultsArray = Array.from(searchResults);
        for (let i = 0; i < searchResultsArray.length; i++) {
          const linkElement = searchResultsArray[i].querySelector('a[href*="/products/"]');
          const foundLockElement = lockElements.find(element => linkElement.getAttribute('href').includes('/products/' + element.handle)) 
          const priceElement = searchResultsArray[i].querySelector(window.Login.search_price_selector);
          if (priceElement) {
            const checkPriceElement = priceElement.querySelector(`.bss-lock-element`);
            if (!checkPriceElement && foundLockElement) {
              priceElement.innerHTML = foundLockElement.lockElement;
              priceElement.style.visibility = 'visible';
            }
          }

          }
      }
    }
  }
  const pCardObeserver = new MutationObserver(pCardCallback);
  pCardObeserver.observe(document.body, config);



  //handle product page
  const productPage = window.location.pathname.includes('/products/');
  if (productPage) {
    const productHandle = window.location.pathname.split('/').pop();
    const foundLockElement = lockElements.find(element => element.handle === productHandle);
    const priceElements = $(`${window.Login.pdp_product_selector} ${window.Login.pdp_price_selector}`)[0];
    if (priceElements) {

      if (foundLockElement?.lock) {
        priceElements.innerHTML = foundLockElement.lockElement;
      } else {
        // restore add to cart buttons
        const cartBtns = $(`${window.Login.pdp_product_selector}:has(${window.Login.pdp_price_selector}) ${window.Login.product_cart_selector}`)[0];
        if (cartBtns) {
          cartBtns.style.cursor = 'initial';
          cartBtns.style.opacity = '1';
          cartBtns.style.pointerEvents = 'auto';
        }
  
        // restore qty selector
        const qtySelector = $(`${window.Login.pdp_product_selector}:has(${window.Login.pdp_price_selector}) ${window.Login.qty_form_selector}`)[0];
        if (qtySelector) {
          qtySelector.style.cursor = 'initial';
          qtySelector.style.opacity = '1';
          qtySelector.style.pointerEvents = 'auto';
        }
      }
      priceElements.style.visibility = 'visible';
    }


    const targetNode = document.querySelector(window.Login.pdp_product_selector);
    const callback = function(mutationsList) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const priceElements = $(`${window.Login.pdp_product_selector} ${window.Login.pdp_price_selector}`)[0];
          if (priceElements) {
            const checkPriceElement = priceElements.querySelector(`.bss-lock-element`);
            if (!checkPriceElement && foundLockElement) {
              priceElements.innerHTML = foundLockElement.lockElement;
            }
            priceElements.style.visibility = 'visible';
          }
        }
      }
    };
    const observer = new MutationObserver(callback);
    if (targetNode) observer.observe(targetNode, config);
  }
})

const handleHideProductForPredictiveSearch = (lockElements) => {
  // fix for task SALTAPBS-1311 and SALTAPBS-1305
  console.log(lockElements.length, 'lockElements')
  let a = []
  const searchResults = document.querySelectorAll(window.Login.search_product_selector);
  searchResults.forEach((searchResult) => {
    const linkElement = searchResult.querySelector('a[href*="/products/"]');
    const foundHideProductElement = lockElements.find(element => linkElement.getAttribute('href').includes('/products/' + element.handle) && element.hideProduct)
    if (foundHideProductElement) {
        a.push(foundHideProductElement)
      searchResult.style.display = 'none';
    }
  })
  console.log(a.length, 'a')
}